import { Link, Text, Tooltip } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
import { PlaceholderText } from '@/components/common/PlaceholderText';
import { useGraphUser } from '@/hooks/graph';
import { paths } from '@/utility/global_paths';

type Props = {
  oid: string | null | undefined;
};

export const UserNameLink = ({ oid }: Props) => {
  const { data: user, isLoading } = useGraphUser(oid);

  if (!oid) return <PlaceholderText>N/A</PlaceholderText>;

  if (isLoading) {
    return (
      <Text color="slate.500" fontSize="sm">
        Loading...
      </Text>
    );
  }

  if (user?.displayName) {
    return (
      <Tooltip label={oid}>
        <Link as={ReactRouterLink} fontSize="sm" to={paths.userByOid(oid)}>
          {user.displayName}
        </Link>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={oid}>
      <Link as={ReactRouterLink} fontFamily="mono" fontSize="sm" to={paths.userByOid(oid)}>
        {oid.length > 19 ? `${oid.slice(0, 8)}...${oid.slice(-8)}` : oid}
      </Link>
    </Tooltip>
  );
};
